exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.claim-logo[data-v-863291fc] {\n  width: 120px;\n  height: 120px;\n}\n.hr[data-v-863291fc] {\n  background-color: #ECECEC;\n  height: 2px;\n  border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-863291fc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ClaimInfoPage.vue
// module id = 1558
// module chunks = 0